import { useEffect, useState } from 'react';
import { loadInterestGoodsList, loadInterestGoodsListCount } from '../api/store';
import MyInterestProductCard from '../components/store/store_product_list/MyInterestProductCard';
import ProductGridHorizontal from '../components/store/store_product_list/ProductGridHorizontal';
import ProductList from '../components/store/store_product_list/ProductList';
import CategoryBar from '../components/util/CategoryBar';
import Loading from '../components/util/Loading';
import { useAuth } from '../context/AuthContext';
import './StorePage.css';

const MyInterest = () => {
  const { profile } = useAuth();
  const [totalData, setTotalData] = useState(0);
  const [isLoading, setIsLoading] = useState(true);

  const categories = [
    { id: 1, name: '스토어 홈', storeType: 'home' },
    { id: 2, name: '일반상품', storeType: 'normal' },
    { id: 3, name: '정기배송', storeType: 'delivery' },
    { id: 4, name: 'MY❤️', storeType: 'myInterest' },
  ];

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(()=> {
    console.log('profile: ',profile);
    if (profile === undefined) {
      return;
    }

    else if (profile === null) {
      setIsLoading(false);
      return;
    }

    if(totalData === 0) {
    loadInterestGoodsListCount(profile.member_seq)
    .then(({count, error}) => {
      if (!error) {
        setTotalData(count);
        setIsLoading(false);
        console.log(totalData);
      }
    })
  }
  }, [profile, totalData]);

  const fetchData = (start, end) => {
    return loadInterestGoodsList(profile.member_seq, start, end);
  }

  if(isLoading) {
    return (
      <div className="container">
        <CategoryBar categories={categories} currentCategory={'myInterest'} />
        <Loading message="Loading..." />
      </div>
    );
  }
  else if (profile === null) {
    return (
      <div className="container">
        <CategoryBar categories={categories} currentCategory={'myInterest'} />
        <div style={{position: 'relative'}}>
          <img src="/store_my_interest_not_login.png" style={{width: '100%', marginTop: "2px"}} alt="store_myinterest" />
          {/* eslint-disable-next-line */}
          <a href="/login" style={{position: 'absolute', bottom: '10%', left: '30%', right: '0', width: '50%', height: '10%'}}></a>
        </div>
      </div>
    );
  }

  else if (profile && totalData === 0) {
    return (
      <div className="container">
        <CategoryBar categories={categories} currentCategory={'myInterest'} />
        <div style={{textAlign: 'center', marginTop: '100px'}}>찜한 상품이 없어요.😂</div>
      </div>
    );
  }

  //로그인 && 찜할 상품이 있을 떄 
  else {
    return (
      <div className="container">
        <CategoryBar categories={categories} currentCategory={'myInterest'} />
        <h2 className="my-interest-title">{profile.name}님이<br/>찜한 상품이에요👀</h2>
        <ProductList 
        fetchData={fetchData} 
        totalData={totalData} 
        dataPerFetch={8} 
        ItemComponent={MyInterestProductCard}
        GridComponent={ProductGridHorizontal}/>
      </div> )
  }
};

export default MyInterest;
